export default "__VITE_ASSET__InpMIAYK__"